export default function (other) {
  other = other || {}
  return {
    id: other.id || null,
    name: other.name || null,
    active: other.active != null ? other.active : true,
    creationTime: other.creationTime || null,
    createdByUserId: other.createdByUserId || null,
  }
}
